module.exports = __webpack_public_path__ + "static/img/tong.924b1b29.png";